export default __webpack_public_path__ + "static/media/I37.36fdc79f.jpg";